const base = {
  logo: "Request to reset your password",
  fields: {
    username: {
      info: "",
      label: "Username",
      required: "The field cannot be empty",
      placeholder: "your@email.com"
    },
    uid: {
      info: "",
      label: "UID",
      required: "The field cannot be empty",
      placeholder: "AAA-AA-AAAAA"
    }
  },
  forgot: {
    label: "Reset Password",
    tooltip: "Click to reset your password"
  },
  forgotDescription: "We will send you a link to reset your password"
};
function getDefaultTexts(texts) {
  const forgotUserName = texts?.fields?.username;
  const loginUID = texts?.fields?.uid;
  const forgotBtn = texts?.forgot;
  const forgotDesc = texts?.forgotDescription;
  return {
    fields: {
      username: {
        info: forgotUserName?.info ?? base.fields.username.info,
        label: forgotUserName?.label ?? base.fields.username.label,
        required: forgotUserName?.required ?? base.fields.username.required,
        placeholder: forgotUserName?.placeholder ?? base.fields.username.placeholder
      },
      uid: {
        info: loginUID?.info ?? base.fields.uid.info,
        label: loginUID?.label ?? base.fields.uid.label,
        required: loginUID?.required ?? base.fields.uid.required,
        placeholder: loginUID?.placeholder ?? base.fields.uid.placeholder
      }
    },
    forgot: {
      label: forgotBtn?.label ?? base.forgot.label,
      tooltip: forgotBtn?.tooltip ?? base.forgot.tooltip
    },
    forgotDescription: forgotDesc ?? base.forgotDescription
  };
}
export {
  getDefaultTexts
};
//# sourceMappingURL=getDefaultTexts.js.map
